/**
 * CUSTOM
 * This code has been developed for this solution.
 */
import {
  SchemaCreateData,
  SchemaQueryData,
  SchemaUpdateData,
} from "../../core/models/Schema";
import NetworkServiceFactory from "../../core/services/network/NetworkService";
import { DEFAULT_QUERY_DATA } from "../../core/services/network/NetworkTypes";
import { useSchemasContext } from "./SchemasContext";

const useSchemasActions = () => {
  const {
    setSchemasResponseData,
    setSchemasLoading,
    setSelectedSchema,
    setSchemasError,
    schemasResponseData,
  } = useSchemasContext();

  const dispatchGetSchemas = async (
    query: SchemaQueryData = DEFAULT_QUERY_DATA()
  ) => {
    const networkService = NetworkServiceFactory.shared;
    try {
      setSchemasLoading(true);
      const data = await networkService.getSchemas(query);
      setSchemasResponseData(data);
      setSchemasError(undefined);
      return data;
    } catch (e: any) {
      setSchemasError(e);
    } finally {
      setSchemasLoading(false);
    }
  };

  const dispatchGetSchema = async (schemaId: number) => {
    const networkService = NetworkServiceFactory.shared;
    try {
      const schema = await networkService.getSchema(schemaId);
      setSelectedSchema(schema);
      setSchemasError(undefined);
    } catch (e: any) {
      setSchemasError(e);
    }
  };

  const dispatchCreateSchema = (query: SchemaCreateData) => {
    const asyncCall = async () => {
      try {
        const data = await NetworkServiceFactory.shared.postSchema(query);
        try {
          if (schemasResponseData) {
            const data =
              await NetworkServiceFactory.shared.getSchemas(
                schemasResponseData
              );
            setSchemasResponseData(data);
          }
        } catch (e) {
          // Pass
        }
        setSelectedSchema(data);
        setSchemasError(undefined);
      } catch (e: any) {
        setSchemasError(e);
      }
    };
    asyncCall().catch();
  };

  const dispatchPatchSchema = (query: SchemaUpdateData) => {
    const asyncCall = async () => {
      try {
        const data = await NetworkServiceFactory.shared.patchSchema(query);
        try {
          if (schemasResponseData) {
            const data =
              await NetworkServiceFactory.shared.getSchemas(
                schemasResponseData
              );
            setSchemasResponseData(data);
          }
        } catch (e) {
          // Pass
        }
        setSelectedSchema(data);
        setSchemasError(undefined);
      } catch (e: any) {
        setSchemasError(e);
      }
    };
    asyncCall().catch();
  };
  const dispatchPutSchema = (query: SchemaUpdateData) => {
    const asyncCall = async () => {
      try {
        const data = await NetworkServiceFactory.shared.putSchema(query);
        try {
          if (schemasResponseData) {
            const data =
              await NetworkServiceFactory.shared.getSchemas(
                schemasResponseData
              );
            setSchemasResponseData(data);
          }
        } catch (e) {
          // Pass
        }
        setSelectedSchema(data);
        setSchemasError(undefined);
      } catch (e: any) {
        setSchemasError(e);
      }
    };
    asyncCall().catch();
  };

  const dispatchCleanSchemasContext = () => {
    setSchemasResponseData(undefined);
    setSchemasError();
    setSelectedSchema();
  };

  return {
    dispatchGetSchemas,
    dispatchGetSchema,
    dispatchCleanSchemasContext,
    dispatchCreateSchema,
    dispatchPatchSchema,
    dispatchPutSchema,
    setSchemasLoading,
  };
};

export { useSchemasActions };
